import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    borderRadius: theme.sizes.roundCorners,
    backgroundColor: theme.colors.card_background_secondary,
    overflow: 'hidden',
    marginBottom: theme.spacing(2)
  },
  trigger: {
    padding: 0
  },
  containerDark: {
    backgroundColor: theme.colors.card_background_secondary,
    padding: theme.spacing(6, 8),
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  modal: {
    '&:first-child': {
      paddingTop: theme.spacing(12)
    },
    padding: theme.spacing(12),
    backgroundColor: theme.colors.card_background_primary_editable
  },
  title: {
    textAlign: 'center',
    display: 'flex',
    alignItems: 'baseline'
  },
  readOnly: {
    color: theme.colorPalette.white_10
  },
  titleLine: {
    borderBottom: `1px solid ${theme.colorPalette.white_30_op_30}`,
    paddingBottom: theme.spacing(6),
    marginBottom: theme.spacing(6)
  },
  totalLine: {
    borderTop: `1px solid ${theme.colorPalette.green_15}`,
    paddingTop: theme.spacing(4),
    marginTop: theme.spacing(6)
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(2),
    top: theme.spacing(2)
  },
  price: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end'
  },
  tooltip: {
    position: 'relative',
    fontSize: 10
  },
  loader: {
    marginRight: theme.spacing(2)
  }
}));

export default useStyles;
